import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';

const icons = {
  SupervisorAccountIcon
};

const approval = {
  id: 'Approv',
  type: 'group',
  children: [
    {
      id: 'Approv',
      title: 'Assign Vendor',
      type: 'item',
      url: '/Approved-Cases',
      icon: icons.SupervisorAccountIcon,
    }
  ]
};

export default approval;
